export const TEMPLATE_STEP = {
    ACTIVITY: "activity",
    RISKY_POSITION: "riskyPosition",
    PREREQUIS: "prerequis",
    TASKS: "tasks",
    LOCATION_SALARY: "locationSalary",
    CONFIRMATION: "confirmation",
};

// Wizard order: the context's `templatePage` is the 1-based position in this list.
export const TEMPLATE_STEPS = [
    { key: TEMPLATE_STEP.ACTIVITY, defaultLabel: "Secteur d'activité" },
    { key: TEMPLATE_STEP.RISKY_POSITION, defaultLabel: "Poste à risque" },
    { key: TEMPLATE_STEP.PREREQUIS, defaultLabel: "Prérequis" },
    { key: TEMPLATE_STEP.TASKS, defaultLabel: "Tâches" },
    { key: TEMPLATE_STEP.LOCATION_SALARY, defaultLabel: "Lieu & rémunération" },
    { key: TEMPLATE_STEP.CONFIRMATION, defaultLabel: "Confirmation" },
];

export const TEMPLATE_STEPS_COUNT = TEMPLATE_STEPS.length;

export const getTemplateStepKey = (templatePage) =>
    TEMPLATE_STEPS[templatePage - 1]?.key;

export const getTemplateStepPage = (stepKey) =>
    TEMPLATE_STEPS.findIndex((step) => step.key === stepKey) + 1;

export const getTemplateStepLabel = (language, step) =>
    language.getValue(`missionTemplate.steps.${step.key}`, step.defaultLabel);
